import axios from "./http"
import base from "./base"

export function sendSmsMsg (data) {
  return axios({
    // url:`${base.url}/minihttp/v3/sendSmsMsg`,
    url: "hm/user/sendsmscode",
    method: "POST",
    data,
  })
}
/**
 * @description 绑定用户手机
 *
 * */
export const bindingMoile = (data) => {
  return axios({
    url: `hm/user/bindphone`,
    data,
    method: "POST",
  })
}
/**
 * @description 获取banner
 *
 * */
export function getBannerList (data) {
  return axios({
    url: "/ad/adbanner/getBannerList",
    method: "POST",
    data,
  })
}

/**
 * @description 福利-导航图标列表
 * @param {object} params
 */
export function getNavigationListAPI (data) {
  return axios({
    url: "/ad/giftCenter/getNavigationList",
    data,
    method: "POST",
  })
}

/*
 * @description 根据市区获取城市
 * @param {object} params
 */
export function getCityApi (data) {
  return axios({
    url: "/ad/welfare/getGoodsDistrict",
    data,
    method: "POST",
  })
}

/**
 * @description 话费充值页面数据
 * @param {object} params
 */
export function getRechargePhoneDetail (data) {
  return axios({
    url: "/ad/adRechargeProduct/list",
    data,
    method: "POST",
  })
}

/**
 * @description 查询话费充值说明
 * @param {object} data
 */
export function getRechargePhoneExplain (data) {
  return axios({
    url: "ad/adRechargeProduct/dictionary",
    data,
    method: "POST",
  })
}

/**
 * @description 话费充值记录页面数据
 * @param {object} params
 */
export function getRechargeOrderRcord (data) {
  return axios({
    url: "/ad/adRechargeOrder/myRechargeOrderPage",
    data,
    method: "POST",
  })
}

/**
 * @description 手机号码运营商查询
 * @param {object} params
 */
export const searchPhoneOperator = (params) => {
  return axios({
    url: "/ad/adRechargeOrder/queryPhoneOperator",
    params,
    method: "GET",
  })
}

/**
 * @description 手机号码慢充运营商查询
 * @param {object} params
 */
export const searchPhoneSlowCharge = (params) => {
  return axios({
    url: `/ad/adRechargeProduct/queryRegion?phone=${params.phone}&businessCode=${params.businessCode}`,
    method: "GET",
  })
}

// @description 用ticket获取用户信息
export const getUserInfo = (params) => {
  return axios({
    url: "/hm/user/user_info",
    params,
    method: "GET",
  })
}

/**
 * @description 商务合作查看
 * @param {object} params
 */
export const rechargePhoneHandler = (data) => {
  return axios({
    url: "/ad/adRechargeOrder/commitOrder",
    data,
    method: "POST",
  })
}

/**
 * @description 我的订单-获取订单列表
 * @param {object} params
 */
export const getMyOrderListApi = (data) => {
  return axios({
    // url: "/ad/adProductOrder/myOrderPage",
    url: "/hm/order/my/list",
    data,
    method: "POST",
  })
}

/**
 * @description 我的订单详情-获取订单详情   /ad/adProductOrder/myOrderDetail 旧接口，查所有订单详情， ad/adOrder/detail/${orderNo}新接口查吃喝玩乐订单详情接口
 * @param {object} params
 */
export const getMyOrderDetailApi = (orderNo) => {
  return axios({
    url: `ad/adOrder/detail/${orderNo}`,
    method: "GET",
  })
}

/*
 * @description 我的订单-删除已关闭订单
 * @param {object} params
 */
export const delOrderApi = (data) => {
  return axios({
    url: "/ad/adOrder/deleteOrder",
    data,
    method: "POST",
  })
}

/*
 * @description 核销页面
 * @param {object} params
 */
export const getCheckDetailApi = (data) => {
  return axios({
    url: "/ad/adOrder/getCheckDetail",
    data,
    method: "POST",
  })
}

/*
 * @description 我的订单--取消订单
 * @param {object} params
 */
export const cancelOrderApi = (data) => {
  return axios({
    url: "/ad/adOrder/cancelOrder",
    data,
    method: "POST",
  })
}

/*
 * @description 我的订单-发起支付
 * @param {object} params
 */
export const startPayApi = (data) => {
  return axios({
    url: "/ad/adOrder/startPay",
    data,
    method: "POST",
  })
}

/**
 * @description 分类-获取分类列表
 * @param {object} params
 */
export const getcategoryListAPI = (data) => {
  return axios({
    url: "/ad/adProductCategory/categoryPage",
    data,
    method: "POST",
  })
}

/**
 * @description 商品详情-获取数据
 * @param {object} params
 */
export const getGoodsDataApi = (data) => {
  return axios({
    url: "/ad/adProduct/detailProductPage",
    data,
    method: "POST",
  })
}

/**
 * @description 获取未登录ticket票据
 * @param {object} params
 */
export const getTicketApi = (data) => {
  return axios({
    url: "/hm/service/ticket",
    data,
    method: "GET",
  })
}

/**
 * @description 获取用户个人ticket
 * @param {object} params
 */
export const getUserTicketApi = (data) => {
  return axios({
    url: "/hm/wechat/openidurl",
    data,
    method: "POST",
  })
}

/**
 * @description 手机号码充值是否成功回调查询
 * @param {object} params
 */
export const searchQueryPayStatus = (data) => {
  return axios(
    {
      url: `ad/adRechargeOrder/queryPayStatus?id=${data}`,
      method: "GET",
    },
    false
  )
}

/*
 * @description 卡券下单接口
 * @param {object} params
 */
export const couponCommitOrderApi = (data) => {
  return axios({
    url: "ad/adOrder/commitOrder",
    data,
    method: "POST",
  })
}

/**
 * @description 商品详情-下单购买
 * @param {object} params
 */
export const commitOrderApi = (data) => {
  return axios({
    url: "ad/adProductOrder/commitOrder",
    data,
    method: "POST",
  })
}

/**
 * @description 福利-推荐标签列表(全网最低)
 * @param {object} params
 */
export const getRecommendLabelListAPI = (data) => {
  return axios({
    // url: 'ad/giftCenter/getRecommendLabelList',
    url: "/ad/adProductCategory/firstCategoryList",
    data,
    method: "POST",
  })
}

/**
 * @description 福利-推荐标签列表
 * @param {object} params
 */
export const getRecommendListAPI = (data) => {
  return axios({
    url: "ad/giftCenter/getRecommendList",
    data,
    method: "POST",
  })
}

/**
 * @description 商品详情-根据商品分类获取充值说明
 * @param {object} params
 */
export const getRechargeExplainApi = (data) => {
  return axios({
    url: "ad/adProduct/queryProductDetailByProductId",
    data,
    method: "POST",
  })
}

// @description 小程序跳转H5-获取用户ticket
export const getWxTicketApi = (data) => {
  return axios({
    url: "/hm/user/mp_login",
    data,
    method: "POST",
  })
}

/*
 * @description 获取吃喝玩乐列表
 * @param {object} params
 */
export const getChiHeClassiListApi = (data) => {
  return axios({
    url: "ad/welfare/getNearbyGoods",
    data,
    method: "POST",
  })
}

/*
 * @description 根据市区获取城市
 * @param {object} params
 */
export const getSetMealDetailApi = (data) => {
  return axios({
    url: "ad/welfare/getPackageDetails",
    data,
    method: "POST",
  })
}

/*
 * @description 卡券下单接口
 * @param {object} params
 */
export const getApplyShopApi = (data) => {
  return axios({
    url: "ad/welfare/getApplyShop",
    data,
    method: "POST",
  })
}

/*
 * @description 获取吃喝玩乐城市
 * @param {object} params
 */
export const getGoodsCityApi = (data) => {
  return axios({
    url: "ad/welfare/getGoodsCity",
    data,
    method: "POST",
  })
}

/*
 * @description 获取吃喝玩乐热门城市
 * @param {object} params
 */
export const getHotCityApi = (data) => {
  return axios({
    url: "ad/welfare/getHotCity",
    data,
    method: "POST",
  })
}

/*
 * @description 支付后更改支付状态
 * @param {object} params
 */
export const changePayStatusApi = (data) => {
  return axios({
    url: "ad/adOrder/changePaid",
    data,
    method: "POST",
  })
}

/*
 * @description 获取吃喝玩乐分类
 * @param {object} params
 */
export const getChiHeClassifyApi = (data) => {
  return axios({
    url: "ad/welfare/getGoodsSort",
    data,
    method: "POST",
  })
}

/*
 * @description 获取商品城市列表
 * @param {object} params
 */
export const getGoodsCityListApi = (data) => {
  return axios({
    url: "ad/welfare/getGoodsCity",
    data,
    method: "POST",
  })
}

/*
 * @description 高德坐标转换
 * @param {object} params
 */
export const getcoordinateApi = (data) => {
  return axios({
    url: "/hm/lbs/convert",
    data,
    method: "POST",
  })
}

/*
 * @description 退款页面
 * @param {object} params
 */
export const getRefundDetailApi = (data) => {
  return axios({
    url: "ad/adOrder/getRefundDetail",
    data,
    method: "POST",
  })
}

/*
 * @description 退款
 * @param {object} params
 */
export const refundOrderApi = (data) => {
  return axios({
    url: "ad/adOrder/refundOrder",
    data,
    method: "POST",
  })
}

/*
 * @description 获取公众号URL签名
 * @param {object} params
 */
export const getUrlApi = (data) => {
  return axios({
    url: "/hm/wechat/jsapi_signture",
    data,
    method: "POST",
  })
}

/*
 * @description 获取公众号URL签名(公众号定位)
 * @param {object} params
 */
export const getJsapiTicketApi = (data) => {
  return axios({
    url: "/hm/wechat/jsapiTicket",
    data,
    method: "POST",
  })
}

/*
 * @description 获取民生网申url
 * @param {object} params
 */
export const getLiveUrlApi = (data) => {
  return axios({
    url: "/hm/cmbc/url",
    data,
    method: "POST",
  })
}

/*
 * @description 民生网申活动url的访问次数
 * @param {object} params
 */
export const getLiveTotalApi = (data) => {
  return axios({
    url: "/hm/cmbc/url/total",
    data,
    method: "POST",
  })
}

/*
 * @description 首页搜索
 * @param {object} params
 */
export const getSearchDataApi = (data) => {
  return axios({
    url: "/hm/search/product",
    data,
    method: "POST",
  })
}

/*
 * @description 获取待付款条数
 * @param {object} params
 */
export const getPaidNum = (data) => {
  return axios({
    url: "/ad/adProductOrder/getWaitPaymentTotal",
    data,
    method: "GET",
  })
}
/**
 * @description 提交头像和昵称----从小程序中获取头像和昵称
 *
 * */
export const bindingUploadUserInfo = (data) => {
  return axios({
    url: `/hm/user/modify_user`,
    data,
    method: "POST",
  })
}

/**
 * @description 话费页面----删除常用账号信息
 *
 * */
export const deleteNumber = (data) => {
  return axios({
    url: `/hm/recharge/used/delete/${data}`,
    data,
    method: "delete",
  })
}
/**
 * @description 话费页面----获取常用账号列表
 *
 * */
export const getRechargeList = (data) => {
  return axios({
    url: `/hm/recharge/used/list`,
    data,
    method: "POST",
  })
}

/**
 * @description 话费页面----保存常用账号信息
 *
 * */
export const saveRecharge = (data) => {
  return axios({
    url: `/hm/recharge/used/save`,
    data,
    method: "POST",
  })
}
